var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRoundBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 73 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.875 33.5041V24.9735C63.875 19.9103 59.7688 15.7677 54.75 15.7677H42.5833C40.2413 15.7677 38.1121 16.6883 36.5 18.1612C34.8879 16.6883 32.7588 15.7677 30.4167 15.7677H18.25C13.2313 15.7677 9.125 19.9103 9.125 24.9735V33.5041C7.26959 35.1919 6.08334 37.6161 6.08334 40.3164V55.6593C6.08334 57.347 7.45209 58.7279 9.125 58.7279C10.7979 58.7279 12.1667 57.347 12.1667 55.6593V52.5907H60.8333V55.6593C60.8333 57.347 62.2021 58.7279 63.875 58.7279C65.5479 58.7279 66.9167 57.347 66.9167 55.6593V40.3164C66.9167 37.6161 65.7304 35.1919 63.875 33.5041ZM42.5833 21.9049H54.75C56.4229 21.9049 57.7917 23.2858 57.7917 24.9735V31.1107H39.5417V24.9735C39.5417 23.2858 40.9104 21.9049 42.5833 21.9049ZM15.2083 24.9735C15.2083 23.2858 16.5771 21.9049 18.25 21.9049H30.4167C32.0896 21.9049 33.4583 23.2858 33.4583 24.9735V31.1107H15.2083V24.9735ZM12.1667 46.4536V40.3164C12.1667 38.6287 13.5354 37.2478 15.2083 37.2478H57.7917C59.4646 37.2478 60.8333 38.6287 60.8333 40.3164V46.4536H12.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundBed);
export default __webpack_public_path__ + "static/media/ic_round-bed.dff4f99f45954f1349d6d4c841cc6817.svg";
export { ForwardRef as ReactComponent };